import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        classifiers: '=',
        skill: '<',
        proficiencies: '='
    },
    template: `
        <div class="modal-header">
            <div class="heading01 heading01b">
                <h2>
                    {{ "skill.Skill" | translate }} :
                    <span ng-if="vm.skill && vm.skill.i18ns">
                        {{ vm.getSkillName(vm.skill) }}
                    </span>
                    <span ng-if="!vm.list || vm.list.loading">Loading employees for skill:</span>
                </h2>
                <ul class="actions01">
                    <li ng-if="vm.showFilter">
                        <a class="btn bordered02 ico-filter" ng-click="vm.toggleFilter()">{{ "skill.closeFilter" | translate }}</a>
                    </li>
                    <li ng-if="!vm.showFilter">
                        <a class="btn bordered02 ico-filter" ng-click="vm.toggleFilter()">{{ "general.Filter" | translate }}</a>
                    </li>
                    <li><a class="btn bordered02" ng-click="vm.uibModalInstance.dismiss()">{{ "general.Close" | translate }}</a></li>
                </ul>
            </div>
        </div>
        <div class="modal-body">
            <modals-user-skills-users-filter
                show-filter="vm.showFilter"
                classifiers="vm.classifiers"
                default-filter="vm.defaultFilter"
                list="vm.list"
                skill-proficiencies="vm.proficiencies"
            />
            <div class="well" ng-if="vm.list.items.length">
                <div class="block01 center">
                    <div class="inner" style="font-size: 16px;">
                        <span> {{ 'skill.average proficiency' | translate }} : </span>
                        <span style="display: inline-block;margin-left: 15px;"><skill-user-bar user-skill="vm.averageUserSkill"/></span>
                    </div>
                </div>
            </div>
            <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
            <div class="well" ng-if="vm.list.items.length">
                <pagination-tools list="vm.list"></pagination-tools>
                <table class="data01 skill-users-table" ng-if="vm.list.items.length">
                    <thead>
                        <tr>
                            <th>{{ 'skill.name' | translate }}</th>
                            <th>{{ 'skill.position' | translate }}</th>
                            <th>{{ 'skill.directManager' | translate }}</th>
                            <th class="w1p">{{ 'skill.proficiency' | translate }}</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="item in vm.list.items track by item.id" class="skill-user-row">
                            <td>
                                <a ng-click="vm.openEmployeeDetails(item.user.id)"
                                    ng-if="vm.PrivilegeService.canViewUsers()">
                                    {{ vm.getUserName(item.user) }}
                                </a>
                                <span ng-if="!vm.PrivilegeService.canViewUsers()">{{ vm.getUserName(item.user) }}</span>
                            </td>
                            <td ng-bind-html="vm.getUserDrls(item.user)"></td>
                            <td>{{ vm.getDirectManagers(item.user) }}</td>
                            <td>
                                <skill-user-bar user-skill="item"/>
                            </td>
                            <td>
                                <action-menu
                                 button-label="Actions"
                                 disabled="!vm.PrivilegeService.canViewUsers()"
                                 menu-style="!vm.PrivilegeService.canViewUsers() && { 'opacity': '0.4', 'cursor': 'default', 'pointer-events': 'none' }"
                                 >
                                    <li>
                                        <a ng-click="vm.openEmployeeDetails(item.user.id)" ng-disabled="!vm.PrivilegeService.canViewUsers()">
                                            {{ 'general.Edit' | translate }}
                                        </a>
                                    </li>
                                </action-menu>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <pagination list="vm.list"></pagination>
            </div>
        </div>
    `
})
export default class {
    constructor (ListFactory, SkillResource, UserSkillResource, $state, $timeout, I18nService, $scope, PrivilegeService,
                 ROLE_COMPANY_MODULE_PRIVILEGE_ENUM) {
        this.$state = $state;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.ListFactory = ListFactory;
        this.SkillResource = SkillResource;
        this.UserSkillResource = UserSkillResource;
        this.I18nService = I18nService;
        this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM = ROLE_COMPANY_MODULE_PRIVILEGE_ENUM;
        this.PrivilegeService = PrivilegeService;
    }

    $onInit () {
        this.getListOfUsers();
        this.showFilter = true;
        this.openActionId = null;
        this.averageUserSkill = null;

        // Watch for list changes to recompute average
        this.$scope.$watch(() => this.list && this.list.items, (newItems, oldItems) => {
            if (newItems !== oldItems) {
                this.computeAverageUserSkill();
            }
        });
    }

    getUserSkills () {
        const items = (this.list && this.list.items) || [];
        if (!items.length) return [];
        const skill = items[0] || {};
        return skill.users || [];
    }

    getSkillProficiencyPoints () {
        let requiredProficiencyPoints = 0;
        if (this.skill && this.skill.required_proficiency_id !== 'undefined' && this.proficiencies) {
            const requiredProficiency = this.proficiencies.find(
                prof => prof.id === this.skill.required_proficiency_id
            );
            if (requiredProficiency && requiredProficiency.points !== null && requiredProficiency.points !== undefined) {
                requiredProficiencyPoints = requiredProficiency.points;
            }
        }

        return requiredProficiencyPoints;
    }

    getSkillName (skill) {
        if (!skill || !skill.i18ns) {
            return `#${skill.id}`;
        }

        const i18n = this.I18nService.getPreferredI18n(skill.i18ns);
        if (i18n && i18n.name) {
            return i18n.name;
        }

        // Fallback to ID if no name found
        return `#${skill.id}`;
    }

    averageProficiencies () {
        const items = (this.list && this.list.items) || [];
        if (!items.length) return 0;

        const proficiencies = items
            .map(item => item.proficiency && item.proficiency.points)
            .filter(value => value !== null && value !== undefined);
        if (!proficiencies.length) return 0;

        let sum = proficiencies.reduce((acc, value) => acc + value, 0);
        let skillRequiredProficiencyPoints = this.getSkillProficiencyPoints();

        const avgGroupProficiency = (sum / proficiencies.length).toFixed(2);
        if (skillRequiredProficiencyPoints !== 0) {
            return [avgGroupProficiency, skillRequiredProficiencyPoints];
        }

        const requiredProficiencies = items
            .map(item => item.requiredProficiency && item.requiredProficiency.points)
            .filter(value => value !== null && value !== undefined);

        sum = requiredProficiencies.reduce((acc, value) => acc + value, 0);
        skillRequiredProficiencyPoints = (sum / requiredProficiencies.length).toFixed(2);
        return [avgGroupProficiency, skillRequiredProficiencyPoints];
    }

    computeAverageUserSkill () {
        const items = (this.list && this.list.items) || [];
        if (!items.length || !this.skill) {
            this.averageUserSkill = null;
            return;
        }

        const avgData = this.averageProficiencies();
        if (!avgData || !Array.isArray(avgData)) {
            this.averageUserSkill = null;
            return;
        }

        const [avgProficiencyPoints, avgRequiredPoints] = avgData;

        // Get proficiencies from skill scale
        const proficiencies = (this.skill.scale && this.skill.scale.proficiencies) || [];

        this.averageUserSkill = {
            proficiency: {
                points: parseFloat(avgProficiencyPoints)
            },
            requiredProficiency: {
                points: parseFloat(avgRequiredPoints)
            },
            skill: {
                scale: {
                    proficiencies
                },
                explanations: this.skill.explanations || []
            },
            proficiencyId: null // Average doesn't have a specific proficiency ID
        };
    }

    getListOfUsers () {
        const prevWidths = {};
        document.querySelectorAll('.bar .fill').forEach(fill => {
            prevWidths[fill.dataset.skillId] = window.getComputedStyle(fill).width;
        });

        this.defaultFilter = {
            skillId: this.skill && this.skill.id,
            includeInactiveSkills: true,
            expand: 'user.directManagers,skill,skill.explanations,skill.explanations.i18ns,skill.explanations.activeI18n,skill.scale.scaleI18ns,skill.scale.proficiencies,skill.activeI18n,' +
                'user.userAssignments,user.drlsWithValue,skill.explanations.proficiency,proficiency.activeI18n,' +
                'requiredProficiency,proficiency,skill.i18ns'
        };

        this.list = this.ListFactory.createWithPagination(this.UserSkillResource.query.bind(this.UserSkillResource));
        this.list.pagination.perPage = 50;

        this.list.fetch(this.defaultFilter);

        // Animate bars after data loads
        this.$timeout(() => {
            const fills = document.querySelectorAll('.bar .fill');
            fills.forEach(fill => {
                const skillId = fill.dataset.skillId;
                const prevWidth = prevWidths[skillId];
                const newWidth = window.getComputedStyle(fill).width;

                if (prevWidth && prevWidth !== newWidth) {
                    // ensure transition is active
                    fill.style.transition = 'width 1s ease-in-out';
                }
            });
        }, 100);
    }

    toggleFilter () {
        this.showFilter = !this.showFilter;
    }

    getUserDrls (user) {
        if (!user || !user.drlsWithValue || user.drlsWithValue.length === 0) {
            return '';
        }
        const formatted = user.drlsWithValue
            .map(d => {
                const parts = [d.departmentName, d.roleName, d.levelName].filter(Boolean);
                return parts.join(', ');
            })
            .filter(Boolean);

        return formatted.join('<br />');
    }

    getDirectManagers (user) {
        if (!user || !user.directManagers || user.directManagers.length === 0) {
            return '';
        }

        return user.directManagers
            .map(manager => manager.displayName)
            .filter(name => name) // Remove any null/undefined names
            .join(', ');
    }

    getUserName (user) {
        if (!user) return '';

        const { firstName, lastName, displayName } = user;

        if (firstName && lastName) {
            return `${firstName} ${lastName}`;
        }

        return displayName || '';
    }

    toggleMenu (id) {
        if (!this.PrivilegeService.canViewUsers()) return;
        this.openActionId = (this.openActionId === id) ? null : id;
    }

    openEmployeeDetails (id) {
        if (!id) return;
        const url = this.$state.href('authorized.user.employee.detail', { id, section: 'skills' });
        window.open(url, '_blank');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/user/skills/users/index.js